import React, { useCallback, useEffect, useState } from 'react';

import { BetStateEnum } from '@app/dev/constants/enums/betState';
import CardItem from '@tickets/components/cardView/item';
import Loader from '@common/components/loader';
import { loadBetHistory } from '../../helper/loadBetHistory';
import EmptyState from '../emptyState';

import './style.scss';

const SportHistory = ({ start, end }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getData = useCallback(async () => {
    if (!start || !end) return;

    setIsLoading(true);

    const resp = await loadBetHistory(start, end);
    setData(resp || []);

    setIsLoading(false);
  }, [start, end]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (isLoading) return <Loader />;

  if (!data.length) return <EmptyState />;

  const onCashout = (ticket, newPrice) => {
    setData(
      data.map((item) => {
        if (item.dataFromSwarm?.barcode !== ticket.dataFromSwarm?.barcode) return item;

        return {
          ...item,
          dataFromSwarm: {
            ...item.dataFromSwarm,
            cashout_amount: newPrice ?? 0,
            state_id: newPrice ? item.dataFromSwarm.state_id : BetStateEnum.CashedOut,
          },
        };
      }),
    );
  };

  return (
    <div className="card-view-tickets-wrp">
      {data.map((ticket) => (
        <CardItem
          key={ticket.id}
          ticket={ticket}
          setTickets={setData}
          tickets={data}
          onCashout={onCashout}
          defaultCashoutAmount={ticket.dataFromSwarm?.cashout_amount}
        />
      ))}
    </div>
  );
};

export default SportHistory;
